export default __webpack_public_path__ + "static/media/2023_image.9b7641ef.png";